var React = require('react');

function IconRadioDisabled (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"icon-radio-disabled","cx":"18","cy":"18","r":"17","fill":"white","fillOpacity":".25","key":0}),React.createElement("circle",{"className":"icon-radio-disabled","cx":"18","cy":"18","r":"17","stroke":"#636F7E","strokeWidth":"2","key":1}),React.createElement("line",{"className":"icon-radio-disabled","y1":"-1","x2":"34","y2":"-1","transform":"matrix(0.707107 -0.707107 -0.707107 -0.707107 6 30.0416)","stroke":"#636F7E","strokeWidth":"2","key":2})]);
}

IconRadioDisabled.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = IconRadioDisabled;

IconRadioDisabled.default = IconRadioDisabled;
